import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';

export interface SectionTabsProps {
  className?: string;
  tabs: Array<SectionTab>;
}

export interface SectionTab {
  // Callback that is triggered if the SectionTab is not active
  handleClick: () => void;
  // Callback that is triggered if the SectionTab is active
  handleActiveClick?: () => void;
  isActive: boolean;
  text: string;
  dataTestAttrs?: DataTestAttrs;
}

function InnerTab({dataTestAttrs, handleActiveClick, handleClick, isActive, text}: SectionTab): JSX.Element {
  const clickCallback = React.useCallback(() => {
    if (isActive && handleActiveClick) {
      handleActiveClick();
    } else if (!isActive) {
      handleClick();
    }
  }, [isActive, handleClick, handleActiveClick]);

  return (
    <li
      className={classNames('sectionTabs-navItem', {active: isActive})}
      onClick={clickCallback}
      {...getTestProps({component: 'SectionTab', element: 'navItem', ...(dataTestAttrs ?? {})})}
    >
      <div className="sectionTabs-navItem-title">
        <span className="sectionTabs-navItem-title-inner">{text}</span>
      </div>
    </li>
  );
}

export default function SectionTabs(props: SectionTabsProps): JSX.Element {
  return (
    <div className={classNames('sectionTabs', props.className)}>
      <ul className="sectionTabs-nav">
        {props.tabs.map((tab, i) => (
          <InnerTab key={i} {...tab} />
        ))}
      </ul>
    </div>
  );
}

SectionTabs.propTypes = {
  className: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      handleClick: PropTypes.func.isRequired,
      handleActiveClick: PropTypes.func,
      isActive: PropTypes.bool.isRequired,
      text: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
};
